﻿import $ from 'jquery';

export class ListBinding {
  public static reorder() {
    const regex = /(.*?)(\d+)(.*)/;

    const list = $("[data-list-binding]");
    const inputs = list.find("input, select, textarea");

    inputs.each(function () {
      const input = $(this);
      if (input == undefined)
        return;

      let nameLeftOver = input.attr("name");
      const nameReplacements = [];

      let idLeftOver = input.attr("id");
      const idReplacements = [];

      const parentListItems = $(input.parents("[data-list-item]").get().reverse());
      parentListItems.each(function () {
        const listItem = $(this);
        const index = listItem.index();

        if (nameLeftOver != null) {
          if (regex.test(nameLeftOver)) {
            nameReplacements.push(nameLeftOver.replace(regex, "$1" + index));
            const result = regex.exec(nameLeftOver);
            nameLeftOver = result[3];
          }
        }

        if (idLeftOver != null) {
          if (regex.test(idLeftOver)) {
            idReplacements.push(idLeftOver.replace(regex, "$1" + index));
            const result = regex.exec(idLeftOver);
            idLeftOver = result[3];
          }
        }
      });

      if (nameReplacements.length > 0) {
        const nameFinal = nameReplacements.join("") + nameLeftOver;
        //console.log("rewriting name: " + input.attr("name") + " => " + nameFinal);
        input.attr("name", nameFinal);
      }

      if (idReplacements.length > 0) {
        const idFinal = idReplacements.join("") + idLeftOver;
        //console.log("rewriting id  : " + input.attr("id") + " => " + idFinal);
        input.attr("id", idFinal);
      }
    });
  }
}

$(() => {
  $(document).on('submit formdatacollecting.rustig.remote', 'form', e => {
    ListBinding.reorder();
  });
})